import React, {  useState, useEffect } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { useQuery } from 'react-query';

import { getParsedContractTypes, getContractTypeById } from 'api/actions/contracts'
import { fetcher } from 'api/client'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'
import { useTranslation } from 'react-i18next';
import { mapDataToReactSelectOptions, getReactSelectOption } from 'utils';

export function DocumentTypesSelect({ isDisabled, value, onChange, ...props }) {
    const {t} = useTranslation()    

    const handleFetchDocumentTypes = async () => {
        const data = await fetcher(getParsedContractTypes())
        return mapDataToReactSelectOptions(data.options)
    }

    const handleChange = (option) => {
        onChange(option || null, option)
    }

    return <AsyncSelect 
        styles={reactSelectStyles}
        placeholder={t('editor.variables.value_placeholder')}
        loadOptions={handleFetchDocumentTypes}
        // isLoading={isLoading}
        defaultOptions 
        cacheOptions
        isDisabled={isDisabled}
        onChange={handleChange}
        value={value ? getReactSelectOption(value) : null}
        {...props}
    />
}